import { useTranslation } from 'react-i18next';

import CustomButton from 'components/common/button/CustomButton';
import CustomInput from 'components/common/forms/CustomInput';
import CustomError from 'components/common/errorLabel/CustomError';
import CustomDropdown from 'components/common/forms/CustomDropdown';
import { IDENTIFIER_TYPE_GLN } from 'utils/constants';
import CustomLoader from 'components/common/loader/CustomLoader';

const ManufacturerSglngenerationSection = ({
	selectedIdentifierType /** selected identifier value dropdown selected state */,
	identifierValue /** selected identifier value state */,
	sglnExtension /** sgln extension input state ig SLN is selected */,
	sgln /** Selected sgln value */,
	identifierTypeList /** identifier type list state */,
	handleChange /** handleChange function for all states */,
	onIdentifierTypeChange /** identifier type handle change function */,
	errorState /** error state  */,
	handleAddSglnToGrid /** add button handle function */,
	allDisabled /** all disabled state for disabling all fields */,
	identifierTypeloading /** loading state for identifier type dropdown */,
	identifierPlaceholder,
	identifierValueError,
	glnErrors,
	sglnErrors,
	fieldDisabled,
	buttonLoading,
}: any) => {
	const { t } = useTranslation('manufacturerModule');

	return (
		<>
			<div className='col-xl-3 col-lg-3 col-sm-6'>
				<div className='form-group'>
					<label className='form-label'>{t('IDENTIFIER_TYPE')}</label>
					<CustomDropdown
						disabled={allDisabled}
						isId
						popupSettings={{
							popupClass: 'default-select-dropdown',
						}}
						className={`form-control default-select-dropdown ${
							errorState?.selectedIdentifierType &&
							errorState?.selectedIdentifierType !== ''
								? 'input-validation-error'
								: ''
						}`}
						dropdownValue={selectedIdentifierType}
						isMandatory
						handleDropDownChange={onIdentifierTypeChange}
						options={identifierTypeList}
						dataItemKey='encManufacturerIdentifierId'
						dataTextField='manufacturerIdentifier'
						loading={identifierTypeloading}
					/>

					{errorState?.selectedIdentifierType &&
						errorState?.selectedIdentifierType !== '' && (
							<CustomError value={errorState?.selectedIdentifierType} />
						)}
				</div>
			</div>

			<div className='col-xl-3 col-lg-3 col-sm-6'>
				<div className='form-group'>
					<CustomInput
						disabled={allDisabled || fieldDisabled}
						className={
							(errorState?.identifierValue && errorState?.identifierValue !== '') ||
							identifierValueError !== '' ||
							glnErrors !== ''
								? 'input-validation-error'
								: ''
						}
						value={identifierValue}
						onChange={handleChange}
						name='identifierValue'
						label={t('IDENTIFIER_VALUE')!!}
						placeholder={identifierPlaceholder || t('IDENTIFIER_VALUE')}
						required={false}
						isMandatory
						type='text'
						error={errorState?.identifierValue || identifierValueError || glnErrors}
						// isMandatory
					/>
				</div>
			</div>

			{selectedIdentifierType === IDENTIFIER_TYPE_GLN && (
				<div className='col-xl-3 col-lg-3 col-sm-6'>
					<div className='form-group'>
						<CustomInput
							disabled={allDisabled || fieldDisabled}
							className={
								errorState?.sglnExtension && errorState?.sglnExtension !== ''
									? 'input-validation-error'
									: ''
							}
							value={sglnExtension}
							onChange={handleChange}
							isMandatory
							name='sglnExtension'
							label={t('SGLN_EXTENSION')!!}
							placeholder={t('SGLN_EXTENSION')}
							required={false}
							type='text'
							error={errorState?.sglnExtension}
							// isMandatory
						/>
					</div>
				</div>
			)}

			{selectedIdentifierType === IDENTIFIER_TYPE_GLN && (
				<div className='col-xl-3 col-lg-3 col-sm-6'>
					<div className='form-group'>
						<CustomInput
							disabled // auto populated
							className={
								(errorState?.sgln && errorState?.sgln !== '') || sglnErrors !== ''
									? 'input-validation-error'
									: ''
							}
							value={sgln}
							onChange={() => {}}
							isMandatory
							name='sgln'
							label={t('SGLN')!!}
							placeholder={t('SGLN')}
							required={false}
							type='text'
							error={errorState?.sgln || sglnErrors}
							// isMandatory
						/>
					</div>
				</div>
			)}
			<div className='bottom-btn-group position-relative-item button-pos-end pb-1 mb-3'>
				<CustomButton
					disabled={allDisabled}
					buttonClassName='k-button k-button-md k-rounded-md k-button-solid k-button-solid-base btn btn-primary h-44px icon-add-btn w-auto mb-3'
					type='button'
					buttonName={buttonLoading ? <CustomLoader /> : t('ADD_BUTTON')}
					handleClick={handleAddSglnToGrid}
				/>
				{errorState?.identifierTypeList && errorState?.identifierTypeList !== '' && (
					<CustomError value={errorState?.identifierTypeList} />
				)}
			</div>
		</>
	);
};

export default ManufacturerSglngenerationSection;
